import { createSlice } from "@reduxjs/toolkit";
import {
  fetchEnquiries,
  fetchEnquiryById,
  closeEnquiry,
  updateEnquiryStage,
} from "./thunk";

interface EnquiryState {
  enquiryList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedEnquiry: any;
  dropdowns: {
    [key: string]: any[];
  };
}

const initialState: EnquiryState = {
  enquiryList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedEnquiry: null,
  dropdowns: {},
};

const enquirySlice = createSlice({
  name: "enquiry",
  initialState,
  reducers: {
    clearSelectedEnquiry: (state) => {
      state.selectedEnquiry = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch enquiries
      .addCase(fetchEnquiries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEnquiries.fulfilled, (state, action) => {
        state.loading = false;
        state.enquiryList = action.payload.data || [];
        state.rowCount = action.payload.rowCount || 0;
      })
      .addCase(fetchEnquiries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || "Failed to fetch enquiries";
        state.enquiryList = [];
      })
      // Fetch enquiry by ID
      .addCase(fetchEnquiryById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEnquiryById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedEnquiry = action.payload;
      })
      .addCase(fetchEnquiryById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || "Failed to fetch enquiry";
      })
      // Close enquiry
      .addCase(closeEnquiry.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(closeEnquiry.fulfilled, (state, action) => {
        state.loading = false;
        // Update the enquiry in the list if it exists
        const updatedEnquiry = action.payload;
        if (updatedEnquiry?.id || updatedEnquiry?.enquiry_id) {
          const enquiryId = updatedEnquiry.id || updatedEnquiry.enquiry_id;
          state.enquiryList = state.enquiryList.map((enquiry) =>
            (enquiry.id === enquiryId || enquiry.enquiry_id === enquiryId)
              ? { ...enquiry, ...updatedEnquiry }
              : enquiry
          );
        }
      })
      .addCase(closeEnquiry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || "Failed to close enquiry";
      })
      // Update enquiry stage
      .addCase(updateEnquiryStage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateEnquiryStage.fulfilled, (state, action) => {
        state.loading = false;
        // Update the enquiry in the list if it exists
        const updatedEnquiry = action.payload;
        if (updatedEnquiry?.id || updatedEnquiry?.enquiry_id) {
          const enquiryId = updatedEnquiry.id || updatedEnquiry.enquiry_id;
          state.enquiryList = state.enquiryList.map((enquiry) =>
            (enquiry.id === enquiryId || enquiry.enquiry_id === enquiryId)
              ? { ...enquiry, ...updatedEnquiry }
              : enquiry
          );
        }
      })
      .addCase(updateEnquiryStage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || "Failed to update enquiry stage";
      });
  },
});

export const { clearSelectedEnquiry, clearError } = enquirySlice.actions;
export default enquirySlice.reducer;

